import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import {
  Button,
  InputLabel,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
  TextField,
  Typography,
  Dialog,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '../../components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useNotification } from 'hooks/useNotification';
import { personalityAPI } from 'services/admin';

// let users = [];
// let personalities = []
// const canais = [
//   "5968720c-56dc-4b56-8b44-ecde91e2d04e",
//   "Sesc Digital",
//   "Av Paulista Digital",
//   "Informação e educação popular",
// ];

function ModalPersonality(props) {
  // const [active, setActive] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedName, setSelectedName] = useState('');
  const [isLoadingModalConfirmation, setIsLoadingModalConfirmation] =
    useState(false);
  const { showConfirmationButton } = useState(true);
  const {
    formState: { isDirty, isValid },
    handleSubmit,
    reset,
    control,
    getValues,
  } = useForm();

  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { setNotify } = useNotification();

  function closeModal() {
    reset();
    setSelectedName('');
    props.onClose();
  }

  async function postData(bodyData) {
    const data = {
      body: bodyData,
    };

    setIsLoading(true);
    return personalityAPI
      .post(data)
      .then(() => {
        setNotify({
          isOpen: true,
          message: 'Personalidade criada com sucesso!',
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        props.getPersonalities();
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function putData(bodyData) {
    setIsLoading(true);
    const data = {
      body: bodyData,
    };

    return personalityAPI
      .put(`/${props.personality.id}`, data)
      .then(resp => {
        setIsLoading(false);
        closeModal();
        props.getPersonalities();
        setNotify({
          isOpen: true,
          message: `Personalidade "${props.personality.name}" atualizada com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        console.log(error.request);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function deleteData() {
    setIsLoadingModalConfirmation(true);
    setIsLoading(true);

    personalityAPI
      .del(`/${props.personality.id}`)
      .then(resp => {
        setIsLoading(false);
        setConfirmDialogAction({ isOpen: false });
        setIsLoadingModalConfirmation(false);
        closeModal();
        props.getPersonalities();
        setNotify({
          isOpen: true,
          message: `Personalidade "${props.personality.name}" removida!`,
          type: 'success',
          title: 'Sucesso!',
        });
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setIsLoadingModalConfirmation(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  useEffect(() => {
    if (props.open === true) {
      setSelectedName(props.personality.name ? props.personality.name : '');
      // async function getUsers() {
      //   return new Promise((resolve,reject) => {
      //   const session = props.authenticatedUser
      //   const idToken = session.getIdToken().getJwtToken();
      //   const apiName = "admin"
      //   const path = "/admin/users"

      //   const data = {
      //     headers: {
      //       'Content-Type': 'application/json',
      //       Authorization: `${idToken}`
      //     }
      //   }

      //   // setIsLoading(true)
      //     adminAPI.get(path, data).then(resp => {
      //       resolve(resp['users'].map(user => {
      //         return {
      //           value: user.userId,
      //           label: user.name
      //         };
      //       }));
      //       // resolve(allUsers)

      //       // setIsLoading(false)
      //     }).catch(error=>{
      //       console.log(error)
      //       // setIsLoading(false)
      //     })
      //   })
      // }

      // async function getChannels() {
      //   return new Promise((resolve,reject) => {
      //   const session = props.authenticatedUser
      //   const idToken = session.getIdToken().getJwtToken();
      //   const apiName = "admin"
      //   const path = "/admin/personalities"

      //   const data = {
      //     headers: {
      //       'Content-Type': 'application/json',
      //       Authorization: `${idToken}`
      //     }
      //   }

      //   // setIsLoading(true)
      //     adminAPI.get(path, data).then(resp => {
      //      resolve(resp['personalityList'].map(personalities => {
      //         return {
      //           value: personalities.id,
      //           label: personalities.name
      //         };
      //       }));
      //       // resolve(allChannels)
      //       // setIsLoading(false)
      //     }).catch(error=>{
      //       console.log(error)
      //       // setIsLoading(false)
      //     })
      //   })
      // }

      //     setIsLoading(true)
      //     Promise.all([
      //     // getChannels(),
      //     getUsers()
      //     ]).then((promises) => {
      //       if (props.action === "create") {
      //         // setAllChannels(promises[0])
      //         setAllUsers(promises[0])
      //         console.log(promises[0])
      //       } else if (props.action === "edit") {
      // //Precisa bater query em cada userID pra pegar o nome?
      //       }
      //       setIsLoading(false); // Adicione um pequeno atraso antes de ocultar o loading
      //     })
    }
  }, [props.open]);

  const onSubmit = data => {
    // Remove fields with empty values
    const formValues = getValues();
    //let filteredFormValues = filterEmptyFields(formValues)
    if (props.action === 'edit') {
      putData(formValues).then(() => {
        closeModal();
      });
    } else if (props.action === 'create') {
      postData(data)
        .then(() => {
          // Reset all fields after post
          closeModal();
        })
        .catch(error => {
          console.log(error);
          //TODO: o que acontece se der erro na inserção?
        });
    }
  };

  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 12,
            }}>
            <DialogTitle
              style={{ lineHeight: 0, color: 'rgba(16, 24, 40, 1)' }}>
              {props.action === 'edit'
                ? 'Editar personalidade'
                : 'Criar personalidade'}
            </DialogTitle>
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}>
            <CloseIcon />
          </IconButton>

          <Typography
            style={{ paddingRight: 24, paddingTop: 4, paddingLeft: 24 }}>
            Preencha as informações de uma nova personalidade.
          </Typography>
          <DialogContent>
            <Form.Group className="mb-3" controlId="formName">
              <div className="label-content">
                <label className="max-char-name">40 caracteres</label>
                <InputLabel className="form-label" htmlFor="name">
                  Personalidade
                </InputLabel>
              </div>

              <Controller
                name={'name'}
                control={control}
                rules={{
                  required: 'O nome da personalidade é obrigatório',
                  minLength: { value: 3, message: 'Mínimo de 3 caracteres' },
                  maxLength: { value: 40, message: 'Máximo de 40 caracteres' },
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      setSelectedName(e.target.value);
                    }}
                    value={selectedName || ''}
                    fullWidth
                    placeholder="Digite o nome"
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.personality.deleted === true
                        ? true
                        : props.personality.deleted === 'true'
                          ? true
                          : false
                    }
                    id="personality_name"
                  />
                )}
              />
            </Form.Group>
          </DialogContent>
          <DialogActions style={{ padding: '0 24px 24px' }}>
            {props.action === 'edit' && (
              <Button
                id="personality_remove_btn"
                style={{
                  color: 'rgba(52, 64, 84, 1)',
                  borderRadius: 8,
                  background: 'rgba(255, 255, 255, 1)',
                  borderColor: 'rgba(208, 213, 221, 1)',
                  padding: '10px 18px',
                  marginLeft: 12,
                  pointerEvents:
                    props.personality.deleted === true
                      ? 'none'
                      : props.personality.deleted === 'true'
                        ? 'none'
                        : '',
                }}
                onClick={() =>
                  setConfirmDialogAction({
                    isOpen: true,
                    title: `Remover ${props.personality.name}?`,
                    subTitle: `Você está removendo a personalidade "${props.personality.name}" permanentemente. Clique remover para confirmar.`,
                    confirmTextButton: 'Remover',
                    color: 'error',
                    children: (
                      <div className="modalRemoveItem">
                        <DeleteOutlineOutlinedIcon
                          color="error"
                          fontSize="8px"
                        />
                      </div>
                    ),
                    onConfirm: () => {
                      deleteData();
                    },
                    showConfirmationButton: { showConfirmationButton },
                    closeTextButton: 'Cancelar',
                  })
                }
                variant="contained"
                className={
                  props.personality.deleted === true
                    ? 'disabled_inactive_button'
                    : props.personality.deleted === 'true'
                      ? 'disabled_inactive_button'
                      : ''
                }>
                Remover
              </Button>
            )}
            <Button
              id="personality_cancel_btn"
              style={{
                marginLeft: 12,
                color: 'rgba(52, 64, 84, 1)',
                borderRadius: 8,
                background: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(208, 213, 221, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}>
              Cancelar
            </Button>
            <Button
              id="personality_save_btn"
              style={{
                color: 'rgba(255, 255, 255, 1)',
                borderRadius: 8,
                marginLeft: 12,
                background: 'rgba(19, 97, 164, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              type="submit"
              disabled={!isDirty || !isValid /*|| active === undefined*/}
              onClick={() => {}}
              className={
                props.personality.deleted === true
                  ? 'disabled_save_button'
                  : props.personality.deleted === 'true'
                    ? 'disabled_save_button'
                    : ''
              }>
              Salvar
            </Button>
          </DialogActions>
          <Modal
            confirmDialogAction={confirmDialogAction}
            setConfirmDialogAction={setConfirmDialogAction}
            isLoadingModalConfirmation={isLoadingModalConfirmation}
            setIsLoadingModalConfirmation={setIsLoadingModalConfirmation}
            showConfirmationButton={showConfirmationButton}
          />
        </Form>
      </Dialog>
    </>
  );
}

export default ModalPersonality;
